import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // If there's a previous page in the history, go back
    // Otherwise, default to landing page
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg text-gray-300 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <button
            onClick={handleBack}
            className="text-blue-500 hover:text-blue-400 transition-colors inline-flex items-center gap-2"
          >
            <ArrowLeftIcon className="w-4 h-4" />
            Back
          </button>
        </div>

        <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>

        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              1. Information We Collect
            </h2>
            <p>When you use Notui, we collect:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Account information (email, name) through Google Sign-In</li>
              <li>Notes and documents you upload or create</li>
              <li>Generated test data and results</li>
              <li>Usage data to improve our services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              2. How We Use Your Information
            </h2>
            <p>We use your information to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Provide and improve our AI-powered services</li>
              <li>Generate personalized study materials</li>
              <li>Maintain and secure your account</li>
              <li>Analyze and enhance user experience</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              3. Data Security
            </h2>
            <p>
              We implement industry-standard security measures to protect your
              data:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Encryption of data in transit and at rest</li>
              <li>Regular security audits and updates</li>
              <li>Secure authentication through Google</li>
              <li>Limited employee access to user data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              4. Data Sharing
            </h2>
            <p>
              We do not sell your personal information. We may share data with:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Service providers that help us operate Notui</li>
              <li>AI processing services for note analysis</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              5. Your Rights
            </h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Access your personal data</li>
              <li>Request data deletion</li>
              <li>Export your notes and data</li>
              <li>Opt-out of certain data processing</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              6. Contact Us
            </h2>
            <p>For privacy-related questions or concerns, contact us at:</p>
            <p className="mt-2">abdulwahiddm1</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
